import React, { useEffect, useState } from 'react'
import profile from "../images/profile.png"
import tick from "../images/tick.png"
import { Button, CircularProgress } from '@mui/material'
import { Checkbox } from 'antd'
import axios from 'axios'
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import {motion} from "framer-motion"
import Map from './map'
import LocationOnIcon from '@mui/icons-material/LocationOn';

const modules={
  toolbar:[
    [{header:[3,4,false] }],
    [{font:[] }],
    ["bold","italic","underline","strike","blockquote"],
    [
      {list: "ordered"},
      {list: "bullet"},
      { indent: "-1"},
      { indent: "+2"}
    ],
    ["link"]
  ]
 }

export default function Create({propsData}) {

    let [verifyForm,ShowVerifyForm]=useState(false)
    function hanldeVerifyPage(e){
        ShowVerifyForm(e.target.checked)
    }
    let [coverPic,handle_cover_pic]=useState("")
    let [shop_name,handle_shop_name]=useState("")
    let [country,handle_country]=useState("")
    let [description,handle_description]=useState("")
    let [shop_type,handle_shop_type]=useState("")
    let [shop_adress,handle_shop_adress]=useState({})
    let [isOpened,handleIsOpened]=useState(false)

    let [loading,setLoading]=useState(false)
    let [error,setError]=useState(false)
    let [errorImage,setErrorImage]=useState(false)
    const [successMessage, setSuccessMessage] = useState('');

    const [selectedFile, setSelectedFile] = useState(null);
   let [showMap,setShowMap]=useState(false)
      
    useEffect(()=>{
          if(!coverPic||!shop_name||!country||!description||!shop_type){
            setError(true)
          }
          else setError(false)

    },[coverPic,shop_name,country,description,shop_type])

    const handleCoverChange=(event)=>{
        handle_cover_pic("")
        let file=event.target.files[0]
       //console.log(file);
        setSelectedFile(file);
        if (file?.size > 1 * 1024 * 1024) {
            setErrorImage('File size should not exceed 1MB');
            return;
          }
        if(file?.type?.startsWith('image')){
            handle_cover_pic(file)
            setErrorImage(false)
        }
        else{
            setErrorImage("Please use valid image")
        }
        
     }

     let navigate=useNavigate()
    const CreateShop=()=>{

        if (!coverPic) {
            setError('Please select a file');
            return;
          }

          setLoading(true);
          setError('');
          setSuccessMessage('');
      
          const formData = new FormData();
          formData.append('file', coverPic);
          formData.append('shope_name', shop_name);
          formData.append('shope_type', shop_type);
          formData.append('description', description);
          formData.append('country', country);
          formData.append('isOpened', isOpened);
          if(shop_adress?.name){
            formData.append('name', shop_adress?.name);
            formData.append('lat', shop_adress?.lat);
            formData.append('lng', shop_adress?.lng);

          }
      
          axios
            .post(`${process.env.REACT_APP_URL}/api/shope/create`, formData, {
              headers: {
                Authorization: `Bearer ${propsData.userData?.token}`,
                'Content-Type': 'multipart/form-data',
              },
            })

            .then((response) => {
              setLoading(false);
              setSuccessMessage('Shop successfully created');
              setSelectedFile(null);
              handle_shop_name("")
              handle_country("")
              handle_cover_pic("")
              handle_description("")
              handle_shop_type("")
              propsData.setEquilizer(propsData.equilizer+2)
              setTimeout(() => {
                setSuccessMessage('');
              }, 3000);
              console.log(response.data);
              navigate(`/shop/${response.data.data?._id}`)
            })

            .catch((error) => {
              setLoading(false);
              console.error(error);
              if (error.response) {
                setError(error.response.data.error||"Error occured please try again !!!");
              } else {
                setError('An error occurred. Please try again.');
              }
              setTimeout(() => {
                setError('');
              }, 10000);
            });
    }
    
  //  console.log(shop_adress);
  return (
      <motion.div 
       initial={{opacity:0,x:250}}
       animate={{opacity:1,x:0}}
       transition={{duration:0.6}}
       className="shop-create">
        <h1>Create new shop</h1>
        <form  className="shop-create-form"  enctype="multipart/form-data">
                        <div className="shop-create-form-each">
                            <div className="shop-create-form-each-title">Shop Cover</div>
                            <input  type='file' value={coverPic?.filename} onChange={handleCoverChange} />
                             {selectedFile && 
                                <>
                                {selectedFile?.type?.startsWith('image') && (
                                    <img src={URL.createObjectURL(selectedFile)} alt="Uploaded" width={200} />
                                ) }       
                                </>
                            }
                            {errorImage&&<div style={{color:"red",fontSize:"13px"}}>{errorImage}</div>}
                        </div>

                        <div className="shop-create-form-each">
                           <div className="shop-create-form-each-title">Shop Name</div>
                            <input type='text' value={shop_name} onChange={(e)=>handle_shop_name(e.target.value)}  placeholder='required' />
                        </div>
                        <div className="shop-create-form-each">
                           <div className="shop-create-form-each-title">Country</div>
                            <input type='text'  value={country} onChange={(e)=>handle_country(e.target.value)} placeholder='required' />
                        </div>
                        <div className="shop-create-form-each">
                           <div className="shop-create-form-each-title">Description</div>
                           <div className="shop-create-form-each-htmlInput"><ReactQuill modules={modules} style={{height:"180px"}}theme="snow" value={description} onChange={(e)=>handle_description(e)} /></div>
                        </div>
                        
                        <div className="shop-create-form-each">
                            <div className="shop-create-form-each-title">Specify Shop type</div>
                            <input type='text' value={shop_type} onChange={(e)=>handle_shop_type(e.target.value)} placeholder='Specify Shop type'/>
                        </div>

                        <div className="shop-create-form-add-adress">
                           <Button onClick={()=>setShowMap(!showMap)}>{shop_adress.name?"Change Adress":"Add adress"}</Button>
                        </div>

                        {shop_adress.name&&<div className="shop-create-added-shop-adress">
                           <div><LocationOnIcon style={{color:"red",fontSize:"50px"}}/></div>
                            <div className="shop-create-added-shop-adress-status">
                               
                                <div  className="shop-create-added-shop-adress-status-each">
                                    <div  className="shop-create-added-shop-adress-status-each-title">Name</div>
                                    <div  className="shop-create-added-shop-adress-status-each-value">{shop_adress?.name}</div>
                                 </div>

                                 <div  className="shop-create-added-shop-adress-status-each">
                                    <div  className="shop-create-added-shop-adress-status-each-title">Latitude</div>
                                    <div  className="shop-create-added-shop-adress-status-each-value">{shop_adress?.lat}</div>
                                 </div>

                                 <div  className="shop-create-added-shop-adress-status-each">
                                    <div  className="shop-create-added-shop-adress-status-each-title">Longitude</div>
                                    <div  className="shop-create-added-shop-adress-status-each-value">{shop_adress?.lng}</div>
                                 </div>
       

                            </div>
                        </div>}

                        <div>Open Shop now &ensp;&ensp; <Checkbox value={isOpened} onChange={(e)=>handleIsOpened(e.target.checked)}/></div>

                         {showMap&&<Map setShowMap={setShowMap} shop_adress={shop_adress} handle_shop_adress={handle_shop_adress} userData={propsData.userData}/>}
                        <div className="shop-create-verify">
                                <div className="shop-create-verify-title">Verify Your Shop   <Checkbox disabled value={verifyForm} onChange={hanldeVerifyPage}/></div>
                                <div className={`shop-create-verify-form ${verifyForm&&"shop-create-verify-form-opened"}`}>
                                    <div className="shop-create-form-each">
                                        <div className='shop-create-form-each-title'>Tin number</div>
                                        <input type='text' placeholder='tin number'/>
                                    </div>

                                    <div className="shop-create-form-each" style={{marginTop:"15px"}}>
                                        <div className='shop-create-form-each-title'>Licence (remember licence owner Should be {propsData.userData.data.username})</div>
                                        <input type='file' />
                                    </div>
                                    
                                    <div className="shop-create-form-each">
                                        <div className='shop-create-form-each-ShowMap'>
                                          <Button>Specify Your place from map</Button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                         {error&&<div style={{textAlign:"center",color:"red"}}>{error}</div>}
                        <div className="shop-create-button">{loading?<CircularProgress size={20}/>:<Button onClick={CreateShop} disabled={error||errorImage}>Create</Button>}</div>

        </form>
     </motion.div>
  )
}
